module.exports = __webpack_public_path__ + "static/media/logolariales.b2b183f0.png";